import { defineComponent as _defineComponent } from 'vue'
import { useSearchStore } from "@/pinia/search";
import { MetadataKeys, SearchTypes, VignetteRoutes } from "@/types";
import { ref } from "vue";
import { useRoute } from "vue-router/composables";
import { useViewAnalytics } from "@/composition/useViewAnalytics";
import SearchPageBrowseByLinks from "@/components/links/SearchPageBrowseByLinks.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  setup(__props) {

const route = useRoute();

const pageName = ref("Search");
const { setAnalyticsMetadata, pushPageViewEvent } = useViewAnalytics(pageName);

const setMetaData = () => {
  setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Search or Content List");
  setAnalyticsMetadata(MetadataKeys.SITESECTION, "Search or Content List");
  pushPageViewEvent();
};

if (route.fullPath.indexOf("search") > -1) {
  setMetaData();
}

const searchStore = useSearchStore();

const activeTab = ref(SearchTypes.VIGNETTE);

return { __sfc: true,route, pageName, setAnalyticsMetadata, pushPageViewEvent, setMetaData, searchStore, activeTab, VignetteRoutes, SearchPageBrowseByLinks }
}

})